import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-transactions-per-day',
  templateUrl: './transactions-per-day.component.html',
  styleUrls: ['./transactions-per-day.component.css']
})
export class TransactionsPerDayComponent implements OnInit {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  constructor() { }

  ngOnInit(): void {
  }

}
